import React from "react";
import { Link } from "react-router-dom";

/**
 * Home / landing page — the brick-wall neon logo fills the screen.
 * Three navigation buttons run across the bottom.
 */
export default function HomePage() {
  const buttons = [
    { label: "Meet the Band", to: "/band", testid: "home-btn-band" },
    { label: "Hear the Band", to: "/music", testid: "home-btn-music" },
    { label: "See the Band", to: "/book", testid: "home-btn-book" },
  ];

  return (
    <section
      data-testid="home-hero"
      className="relative w-full overflow-hidden"
      style={{
        backgroundColor: "#0a0a0a",
        minHeight: "100svh", // iOS Safari-safe viewport height (falls back gracefully)
      }}
    >
      <img
        src="/logos/02_neon_script.png"
        alt="Out Of Touch — neon on brick wall"
        className="absolute inset-0 w-full h-full object-contain object-top md:object-center"
        data-testid="home-logo"
      />

      {/* Bottom nav buttons */}
      <div
        className="absolute inset-x-0 bottom-4 md:bottom-10 z-20 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-5 px-4"
        data-testid="home-cta-row"
      >
        {buttons.map((b) => (
          <Link
            key={b.to}
            to={b.to}
            data-testid={b.testid}
            className="neon-btn w-full sm:w-[260px]"
            style={{ textAlign: "center", whiteSpace: "nowrap", maxWidth: "320px" }}
          >
            {b.label}
          </Link>
        ))}
      </div>
    </section>
  );
}
